<template>
  <section class="tw-min-h-screen tw-h-full tw-flex tw-flex-col">
    <CommonPartenrHeader isLight />
    <section class="partner tw-flex-1 tw-flex tw-justify-center tw-items-center tw-pt-10 tw-pb-20">
      <section class="tw-container tw-mx-auto tw-relative tw-z-0">
        <div class="tw-flex tw-flex-col md:tw-flex-row md:tw-justify-around tw-gap-14">
          <div class="tw-basis-full md:tw-basis-5/12 tw-flex tw-flex-col tw-gap-y-5 md:tw-gap-y-8">
            <h2 class="tw-text-primary tw-text-3xl sm:tw-text-4xl md:tw-text-5xl lg:tw-text-6xl">{{ $t('OTC Partners') }} </h2>
            <h2 class="tw-text-3xl sm:tw-text-4xl md:tw-text-5xl lg:tw-text-6xl tw-font-bold !tw-leading-normal !lg:tw-leading-tight">
              <i18n-t keypath="partner_title"> </i18n-t>
            </h2>
            <h3 class="tw-text-xl md:tw-text-2xl lg:tw-text-3xl !tw-leading-normal">
              <i18n-t keypath="partner_description">
                <template #today>
                  <span class="tw-text-primary">{{ $t('partner_today') }}</span>
                </template>
              </i18n-t>
            </h3>
          </div>
          <div class="tw-basis-full md:tw-basis-5/12 tw-flex tw-items-center tw-justify-center">
            <ClientOnly>
              <section class="tw-flex tw-flex-col tw-w-full tw-gap-7">
                <div class="tw-basis-full">
                  <h5 class="tw-text-white tw-text-xl md:tw-text-2xl tw-font-bold">{{ $t('Apply here') }}</h5>
                  <UITextInput
                    class="tw-mt-5 md:tw-mt-8 tw-rounded-md tw-overflow-hidden tw-text-neutral"
                    type="email"
                    v-model="state.email"
                    size="xl"
                    :placeholder="$t('Enter your email')"
                    :error-messages="(v$.email.$errors.map((e) => e.$message) as string[])"
                  >
                    <template v-slot:append-inner>
                      <button @click="submit" class="tw-btn tw-btn-primary tw-text-accent tw-font-bold tw-relative -tw-right-3 lg:-tw-right-5">
                        {{ $t('Apply') }}
                      </button>
                    </template>
                  </UITextInput>
                </div>
                <div class="tw-basis-full md:tw-order-first">
                  <i18n-t keypath="partner_join_message" tag="p" class="tw-text-base sm:tw-text-lg md:tw-text-xl !tw-leading-relaxed">
                  </i18n-t>
                </div>
              </section>
            </ClientOnly>
          </div>
        </div>
      </section>
    </section>
  </section>
</template>

<script setup lang="ts">
  import { useVuelidate } from '@vuelidate/core'
  const session = useSession()
  const { required, email } = useI18nlidate()

  const state = ref({ email: '' })
  const v$ = useVuelidate({ email: { required: required('Email'), email: email } }, state)
  const localeRoute = useLocaleRoute()

  const submit = async () => {
    const isFormCorrect = await v$.value.$validate()
    if (!isFormCorrect) return
    session.setEmail(state.value.email)

    const _route = localeRoute({ path: 'kyc', query: { role: 'broker' } })
    if (_route) {
      return navigateTo(_route.fullPath)
    }
  }
</script>
<style scoped lang="scss">
  .partner {
    background-image: radial-gradient(circle at 9% 29%, #22222d, #171724 75%);
    color: #ffffff;
    position: relative;

    &::before {
      height: 300px;
      background: url('/res/img/partner/bg-landing.png') no-repeat 40% 50%;
      background-size: cover;
      content: '';
      left: 0;
      position: absolute;
      bottom: 5%;
      pointer-events: none;
      width: 100%;
    }
  }
</style>
